<script setup>
import state from "../CourseFlow/state";
import {ref, toRef} from "vue";
import AddressAutoComplete from "./AddressAutoComplete.vue";
import validator from "../../components/Validator";
import schemaCollection from "../../components/SchemaCollection";
import InfoIcon from "./InfoIcon.vue";

const props = defineProps({
  modelValue: {
    type: Object,
  }
})

const modelValue = toRef(props, 'modelValue');

modelValue.value.suffix = modelValue.value.suffix || '';
modelValue.value.job = modelValue.value.job || '';
modelValue.value.address = modelValue.value.address || {};

const errors = ref({});
const validate = validator(schemaCollection.participant, modelValue, errors)
</script>

<template>
  <div class="formfields">
    <div class="entry__field">
      <label for="big">
        BIG / KRM Nummer
        <InfoIcon :tooltip="state.info.registrationExplainer" />
        <span class="option">Optioneel</span>
      </label>
      <input type="text" pattern="[0-9]*" v-model="modelValue.big" id="big" @blur="modelValue.big.length > 0 ? validate('big') : null">
      <p class="input-error" v-if="!!errors.big">
        {{ errors.big }}
      </p>
    </div>

    <div class="entry__select">
      <label for="job">Functie<span class="required-indicator">*</span></label>
      <div class="c-select dropdown-toggle">
        <select v-model="modelValue.job" required @blur="validate('job')">
          <option value="" disabled>Selecteer</option>
          <option :value="choice" v-for="choice in state.jobChoices">{{ choice }}</option>
        </select>
      </div>
      <p class="input-error" v-if="!!errors.job">
        {{ errors.job }}
      </p>
    </div>

    <div class="infofield">
      {{ state.info.participantNotice }}
    </div>

    <div class="entry__divider">
      <div class="entry__field entry__field--md">
        <label for="firstName">Voornaam<span class="required-indicator">*</span></label>
        <input type='text' id="firstName" placeholder="Voornaam cursist" v-model="modelValue.firstName" aria-label='Voornaam' required  @blur="validate('firstName'); validate('job');"/>
        <p class="input-error" v-if="!!errors.firstName">
          {{ errors.firstName }}
        </p>
      </div>

      <div class="entry__field entry__field--sm">
        <label for="initials">Voorletters<span class="required-indicator">*</span></label>
        <input type='text' placeholder="A" v-model="modelValue.initials" id="initials" aria-label='Voorletters' @blur="validate('initials')" required/>
        <p class="input-error" v-if="!!errors.initials">
          {{ errors.initials }}
        </p>
      </div>
    </div>


    <div class="entry__divider">
      <div class="entry__field entry__field--sm">
        <label for="prefix">Tussenvoegsel</label>
        <input type='text' id="prefix" placeholder="Bijv. de" v-model="modelValue.prefix" aria-label='Tweede naam' />
      </div>

      <div class="entry__field entry__field--md">
        <label id="lastname">Achternaam<span class="required-indicator">*</span></label>
        <input type='text' id="lastname" placeholder="Achternaam cursist" v-model="modelValue.lastName" aria-label='Achternaam' @blur="validate('lastName')" required/>
        <p class="input-error" v-if="!!errors.lastName">
          {{ errors.lastName }}
        </p>
      </div>
    </div>

      <div v-if="state.info.participantEmailNotice" class="infofield">
          {{ state.info.participantEmailNotice }}
      </div>

    <div class="entry__field">

      <label for="email">E-mailadres<span class="required-indicator">*</span></label>
      <input id="email" type='email' placeholder="cursist@provider.nl" v-model="modelValue.email" required @blur="validate('email')" />
      <p class="input-error" v-if="!!errors.email">
        {{ errors.email }}
      </p>
    </div>

    <AddressAutoComplete v-model="modelValue.address" />
  </div>
</template>
